import type { ProceduralRoomContent } from './types';

function enemyForFloor(floor: number): string {
  return floor <= 1 ? 'bone_guard' : 'giant_spider';
}

export function normalEnemyRoomContent(floor: number): ProceduralRoomContent {
  const enemyId = enemyForFloor(floor);
  return {
    name: 'Hành Lang Quái',
    description: 'Bóng đen chuyển động trong góc.',
    safetyTag: 'Nguy hiểm',
    bgImageKey: 'bg_enemy_room',
    isCleared: false,
    isRequiredInteraction: true,
    options: [
      {
        id: `enemy_${floor}`,
        action: 'COMBAT',
        actionText: '⚔️ Giao chiến',
        consequence: {
          triggerCombat: true,
          enemyId,
          message: '⚔️ Kẻ địch chặn đường. Bạn ra tay trước.',
        },
      },
      {
        id: `enemy_flee_${floor}`,
        action: 'ESCAPE',
        actionText: '🏃 Bỏ qua / chạy trốn (50%+DEX)',
        consequence: {
          attemptFlee: true,
          enemyId,
          message: '🏃 Thử lảng tránh…',
        },
      },
    ],
  };
}

export function eliteEnemyRoomContent(floor: number): ProceduralRoomContent {
  return {
    name: 'Phòng Tinh Anh',
    description: 'Kẻ địch mạnh hơn chặn lối.',
    safetyTag: 'Elite',
    bgImageKey: 'bg_enemy_room',
    isCleared: false,
    isRequiredInteraction: true,
    options: [
      {
        id: `elite_${floor}`,
        action: 'COMBAT',
        actionText: '⚔️ Thách đấu Elite',
        consequence: {
          triggerCombat: true,
          enemyId: 'black_knight',
          monsterName: 'Kỵ Sĩ Đen',
          message: '⚔️ Elite xuất hiện. Bạn ra tay trước.',
        },
      },
      {
        id: `elite_flee_${floor}`,
        action: 'ESCAPE',
        actionText: '🏃 Bỏ qua / chạy trốn (50%+DEX)',
        consequence: {
          attemptFlee: true,
          enemyId: 'black_knight',
          message: '🏃 Thử lảng tránh…',
        },
      },
    ],
  };
}
